import type { TFunction } from 'i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import type { RelanceCompletedEventDto } from '../../services/eventHistoryService';
import { formatCurrency, formatShortDate } from '../formatters';
import { formatRelanceOrdinal } from './relanceOrdinal';
import { sortInvoiceNumbers } from './invoiceNumbers';

export interface SentRelanceDescription {
    date: string;
    /** "2e relance envoyée" */
    label: string;
    /** "Facture #39, 69 – 1 799,00 $", or the amount alone when no invoice was named. */
    invoiceLine: string;
}

/** `rank` is the 1-based chronological position of the send: the oldest is the 1re relance. */
export function describeSentRelance(event: RelanceCompletedEventDto, rank: number, t: TFunction, lang: string): SentRelanceDescription {
    const amount = formatCurrency(event.amountDue, lang);
    return {
        date: formatShortDate(event.occurredAt, lang),
        label: t(TranslationKey.Home.FollowUp.RelanceSent, { rank: formatRelanceOrdinal(rank, lang) }),
        invoiceLine: event.invoiceNumbers.length > 0
            ? t(TranslationKey.Home.FollowUp.InvoiceLine, { invoices: sortInvoiceNumbers(event.invoiceNumbers).join(', '), amount })
            : amount,
    };
}
